var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExTable',{attrs:{"dataSource":_vm.dataSource}},[_c('DxEditing',{attrs:{"allow-adding":true,"allow-deleting":true,"allow-updating":true,"mode":"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }